import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Input, Tabs } from "antd";
import { Row, Col, Button } from "react-bootstrap";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ExerciseList from "./ExerciseList";
import Session from "./Sessions";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  createWorkoutTemplate,
  updateWorkoutTemplate,
} from "../../redux/Slices/workoutSlice";
import { postWorkoutApi } from "../../redux/Slices/workoutPlanSlice";
import ToastNotification from "../../components/Common/ToastNotification";
import Loader from "../../components/Common/Loader";
import WorkoutPlaceholder from "../../styles/Assets/workout_placeholder.jpg";
import WorkoutSessionPlaceholder from "../../styles/Assets/workout_session_placeholder.jpeg";
import FormControlTextArea from "../../components/Common/FormControlTextArea";
import FormControl from "../../components/Common/FormControl";
import FormLabel from "../../components/Common/FormLabel";
import { CONSTANTS } from "../../utils/Constant/Constant";
import SessionCard from "./SessionCard";
import getFileAsBase64 from "../../utils/ImageUtils";

const { TabPane } = Tabs;
const WorkoutTemplateBuilder = () => {
  const { trans } = useCustomTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [templateCover, setTemplateCover] = useState(null);
  const [planName, setPlanName] = useState(location.state?.templateName || "");
  const [fetchtemplateImage, SetfetchtemplateImage] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [fetchImage, setFetchImage] = useState(false);
  const [fetchImageCover, setFetchImageCover] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState(null);
  const [newWorkoutPlanId] = useState(uuidv4());
  const [coverState, setCoverState] = useState({
    workoutTemplateImageBase64: "",
    workoutTemplateImageFileName: "",
    workoutTemplateImageMediaType: "",
    workoutTemplateImageFileType: "",
    workoutTemplateImageSourceType: "",

    coverPhotoBase64: "",
    coverPhotoFileName: "",
    coverPhotoMediaType: "",
    coverPhotoFileType: "",
    coverPhotoSourceType: "",
  });
  const [sessions, setSessions] = useState(() => {
    if (location.state?.sessions) {
      return location.state.sessions.map((session, index) => ({
        id: session.id,
        name: session.name,
        sessionImageId: "",
        sessionPhotoBase64: "",
        sessionPhotoFileName: "",
        sessionPhotoMediaType: "",
        sessionPhotoFileType: "",
        sessionPhotoSourceType: "",
        sessionBlobUrl: session?.sessionBlobUrl || "",
        sessionFileType: session?.sessionFileType || "",
        indexOrder: session?.indexOrder || 0,
        sessionType: session.sessionType || "",
        exercises: session.exercises.map((exercise) => ({
          exerciseId: exercise.exerciseId,
          name: exercise.name,
          sets: exercise.sets || trans("ClientWorkout.one"),
          reps: exercise.reps || trans("ClientWorkout.one"),
          sec: exercise.sec || "",
          setType: exercise.setType || "",
          blobUrl: exercise.blobUrl || null,
          exerciseNote: exercise.exerciseNote || "",
          indexOrder: exercise.indexOrder || 0,
        })),
      }));
    }
    setFetchImage(true);
    return [];
  });

  useEffect(() => {
    const fetchBase64Image = async () => {
      if (templateCover?.blobUrl) {
        const base64Image = await getFileAsBase64(templateCover.blobUrl);
        setCoverState((prev) => ({
          ...prev,
          workoutTemplateImageBase64: base64Image,
          coverPhotoBase64: base64Image,
        }));
      }
    };

    fetchBase64Image();
  }, [fetchImageCover, templateCover?.blobUrl]);

  useEffect(() => {
    if (location.state?.templateCoverPhotoImage) {
      setTemplateCover(location?.state?.templateCoverPhotoImage);
      // setFetchImageCover(true);
    } else {
      setTemplateCover(WorkoutPlaceholder);
    }
  }, [location?.state?.templateCoverPhotoImage]);

  useEffect(() => {
    if (templateCover) {
      setFetchImageCover(true);
    } else {
      setFetchImageCover(false);
    }
  }, [templateCover]);

  useEffect(() => {
    const fetchBase64Images = async () => {
      const updatedSessions = await Promise.all(
        sessions.map(async (session) => {
          let sessionPhotoBase64 = session.sessionPhotoBase64 || "";
          if (session.sessionBlobUrl && !sessionPhotoBase64) {
            sessionPhotoBase64 = await getFileAsBase64(session.sessionBlobUrl);
          }
          return {
            ...session,
            sessionPhotoBase64,
            exercises: session.exercises,
          };
        })
      );

      // Only update if base64 images changed
      const changed = updatedSessions.some((updatedSession, index) => {
        return (
          updatedSession.sessionPhotoBase64 !==
          sessions[index].sessionPhotoBase64
        );
      });

      if (changed) {
        setSessions(updatedSessions);
      }
    };

    if (sessions.length > 0) {
      fetchBase64Images();
    }
  }, [fetchImage, sessions]);

  const [isCustomized, setIsCustomized] = useState(false);
  const didFetchBase64Images = useRef(false);

  useEffect(() => {
    const fetchWorkoutPlanImageBase64 = async () => {
      const initialTemplate = location?.state?.initialTemplate;

      if (!initialTemplate || !initialTemplate.workoutTemplateImage?.blobUrl)
        return;

      try {
        const workoutPlanImageBase64 = await getFileAsBase64(
          initialTemplate?.workoutTemplateImage.blobUrl
        );

        setForm((prevForm) => ({
          ...prevForm,
          workoutPlanImageBase64,
          workoutPlanImageFileName:
            initialTemplate?.workoutTemplateImage?.fileName || "",
          workoutPlanImageMediaType:
            initialTemplate?.workoutTemplateImage?.mediaType || "",
          workoutPlanImageFileType:
            initialTemplate?.workoutTemplateImage?.fileType || "",
          workoutPlanImageSourceType:
            initialTemplate?.workoutTemplateImage?.sourceType || "",
        }));
      } catch (error) {
        console.error("Failed to fetch workout plan image base64:", error);
      }
    };

    if (location?.state?.initialTemplate) {
      fetchWorkoutPlanImageBase64();
    }
  }, [fetchtemplateImage, location?.state?.initialTemplate]);

  useEffect(() => {
    if (location?.state?.editActualWorkoutPlan) {
      setForm(null);
      setForm(location?.state?.editActualWorkoutPlan);
    }
  }, [location?.state?.editActualWorkoutPlan]);

  useEffect(() => {
    const fetchBase64Images = async () => {
      if (form && form.clientWorkoutPlanSessionRequests) {
        const updatedSessions = await Promise.all(
          form.clientWorkoutPlanSessionRequests.map(async (session) => {
            let sessionPhotoBase64 = session.sessionPhotoBase64 || "";

            if (session.sessionBlobUrl && !session.sessionPhotoBase64) {
              try {
                sessionPhotoBase64 = await getFileAsBase64(
                  session.sessionBlobUrl
                );
              } catch (error) {
                console.error("Failed to fetch session image:", error);
                sessionPhotoBase64 = "";
              }
            }

            return {
              ...session,
              sessionPhotoBase64,
            };
          })
        );

        // Check if any session's base64 changed
        const changed = updatedSessions.some((updatedSession, index) => {
          return (
            updatedSession.sessionPhotoBase64 !==
            form.clientWorkoutPlanSessionRequests[index].sessionPhotoBase64
          );
        });

        if (changed) {
          setForm((prevForm) => ({
            ...prevForm,
            clientWorkoutPlanSessionRequests: updatedSessions,
          }));
        }
      }
    };

    // Prevent repeated fetching on every form update
    if (form && !didFetchBase64Images.current) {
      fetchBase64Images();
      didFetchBase64Images.current = true;
    }
  }, [form]);

  useEffect(() => {
    if (location?.state?.initialTemplate) {
      const WorkoutTemplate = location?.state?.initialTemplate;
      const mappedForm = {
        clientWorkoutPlanId: newWorkoutPlanId,
        coachId: location?.state?.selectedCoachId,
        clientId: location?.state?.selectedClientId,
        name: "",
        session: WorkoutTemplate.numberOfSessions.toString(),
        description: WorkoutTemplate.description,
        introText: "",
        language: "en",
        plannedVolumeReps: WorkoutTemplate.sessions
          .reduce(
            (acc, session) =>
              acc +
              session.exercises.reduce(
                (sum, exercise) => sum + parseInt(exercise.reps),
                0
              ),
            0
          )
          .toString(),
        plannedVolumeSets: WorkoutTemplate.sessions
          .reduce(
            (acc, session) =>
              acc +
              session.exercises.reduce(
                (sum, exercise) => sum + parseInt(exercise.sets),
                0
              ),
            0
          )
          .toString(),
        plannedVolumeSec: trans("ClientWorkout.zero"),
        workoutPlanImageBase64: "",
        workoutPlanImageFileName: "",
        workoutPlanImageMediaType: "",
        workoutPlanImageFileType: "",
        workoutPlanImageSourceType: "",
        coverPhotoBase64: "",
        coverPhotoFileName: "",
        coverPhotoMediaType: "",
        coverPhotoFileType: "",
        coverPhotoSourceType: "",
        existingWorkoutPlanImageId: null,
        existingCoverPhotoImageId: null,
        createdOrUpdatedBy: location?.state?.selectedCoachId,
        clientWorkoutPlanSessionRequests: WorkoutTemplate.sessions.map(
          (session) => ({
            clientWorkoutPlanId: newWorkoutPlanId,
            clientWorkoutPlanSessionId: session.workoutSessionID,
            clientId: location?.state?.selectedClientId.id,
            exerciseCount: session.exerciseCount,
            totalSets: session.exercises.reduce(
              (sum, exercise) => sum + parseInt(exercise.sets),
              0
            ),
            sessionName: session.sessionName,
            sessionType: "",
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            sessionBlobUrl: session.sessionPhotoImage?.blobUrl || null,
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: session.exercises.map(
              (exercise) => ({
                clientWorkoutPlanSessionId: session.workoutSessionID,
                clientWorkoutPlanExerciseId:
                  exercise.workoutTemplateExercisesId,
                exerciseName: exercise.exerciseName,
                exerciseId: exercise.exerciseID,
                blobUrl: exercise?.exerciseImage?.blobUrl,
                sets: exercise.sets,
                reps: exercise.reps,
                sec: exercise.sec,
                setType: "",
                dropSet: "",
                notes: "",
                indexOrder: exercise.indexOrder || 0,
              })
            ),
          })
        ),
      };
      setForm(mappedForm);
      SetfetchtemplateImage(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.initialTemplate]);

  const isEditing = location.state?.isEditing || false;

  const [activeSessionId, setActiveSessionId] = useState(null);
  const [toastConfig, setToastConfig] = useState(null);

  const { profileData } = useSelector((state) => state.profile);
  const coachId = profileData?.coachId;

  const handleImageRemove = (type) => {
    if (type === CONSTANTS.WORKOUT_PLAN_COVER) {
      setForm((prevData) => ({
        ...prevData,
        workoutPlanImageBase64: null,
      }));
    }
    if (type === "templateMainCover") {
      setCoverState((prev) => ({
        ...prev,
        workoutTemplateImageBase64: "",
        workoutTemplateImageFileName: "",
        workoutTemplateImageMediaType: "",
        workoutTemplateImageFileType: "",
        workoutTemplateImageSourceType: "",
        coverPhotoBase64: "",
        coverPhotoFileName: "",
        coverPhotoMediaType: "",
        coverPhotoFileType: "",
        coverPhotoSourceType: "",
      }));
    }
  };

  const handleAddSessionForm = () => {
    const newId = uuidv4();
    const newSession = {
      clientWorkoutPlanId: newWorkoutPlanId,
      clientWorkoutPlanSessionId: newId,
      clientId: location?.state?.selectedClientId?.id,
      exerciseCount: 0,
      totalSets: 0,
      sessionName: `Session ${
        form?.clientWorkoutPlanSessionRequests?.length + 1
      }`,
      sessionType: "",
      equipment: "",
      sessionPhotoBase64: "",
      sessionPhotoFileName: "",
      sessionPhotoMediaType: "",
      sessionPhotoFileType: "",
      sessionPhotoSourceType: "",
      existingWorkoutPlanSessionImageId: null,
      clientWorkoutPlanExerciseRequests: [],
      indexOrder: form?.clientWorkoutPlanSessionRequests?.length || 0, // Add this
    };

    if (location?.state?.isSelectedFromClient) {
      setForm((prevForm) => ({
        ...prevForm,
        clientWorkoutPlanSessionRequests: [
          // Preserve indexOrder for existing sessions
          ...(prevForm?.clientWorkoutPlanSessionRequests || []).map(
            (s, idx) => ({
              ...s,
              indexOrder: s.indexOrder ?? idx,
            })
          ),
          newSession,
        ],
      }));
    }
  };

  const handleAddSession = () => {
    if (location?.state?.isSelectedFromClient) {
      handleAddSessionForm();
    } else {
      const newSessionId = Date.now();
      const newSessionName = "";
      const newSession = {
        id: newSessionId,
        name: newSessionName,
        exercises: [],
        indexOrder: sessions.length || 0,
      };

      // Preserve indexOrder for existing sessions
      const updatedSessions = sessions.map((s, idx) => ({
        ...s,
        indexOrder: s.indexOrder ?? idx,
      }));

      setSessions([...updatedSessions, newSession]);
      setActiveSessionId(newSessionId);
    }
  };
  const moveSession = (dragIndex, hoverIndex) => {
    if (location?.state?.isSelectedFromClient) {
      setForm((prevForm) => {
        const updatedSessions = [...prevForm.clientWorkoutPlanSessionRequests];

        // Remove the dragged session
        const [removed] = updatedSessions.splice(dragIndex, 1);

        // Insert it at the hover position
        updatedSessions.splice(hoverIndex, 0, removed);

        // Update indexOrder
        const reindexedSessions = updatedSessions.map((session, idx) => ({
          ...session,
          indexOrder: idx,
        }));

        return {
          ...prevForm,
          clientWorkoutPlanSessionRequests: reindexedSessions,
        };
      });
    } else {
      setSessions((prevSessions) => {
        const updatedSessions = [...prevSessions];

        // Remove the dragged session
        const [removed] = updatedSessions.splice(dragIndex, 1);

        // Insert at the hover position
        updatedSessions.splice(hoverIndex, 0, removed);

        // Update indexOrder
        const reindexedSessions = updatedSessions.map((session, idx) => ({
          ...session,
          indexOrder: idx,
        }));

        return reindexedSessions;
      });
    }
  };

  const handleRemoveSession = (id) => {
    if (location?.state?.isSelectedFromClient) {
      setForm((prevForm) => {
        const updatedSessions = prevForm.clientWorkoutPlanSessionRequests
          .filter((session) => session.clientWorkoutPlanSessionId !== id)
          .map((session, idx) => ({
            ...session,
            indexOrder: idx,
          }));

        return {
          ...prevForm,
          clientWorkoutPlanSessionRequests: updatedSessions,
        };
      });
    } else {
      setSessions((prevSessions) =>
        prevSessions
          .filter((s) => s.id !== id)
          .map((s, idx) => ({
            ...s,
            indexOrder: idx,
          }))
      );

      if (activeSessionId === id) {
        setActiveSessionId(null);
      }
    }
  };

  const handleSaveTemplate = () => {
    const hasEmptySessionName = sessions.some(
      (session) => !session.name.trim()
    );

    if (hasEmptySessionName) {
      setToastConfig(null);
      setTimeout(() => {
        setToastConfig({
          type: "error",
          message: trans("WorkoutTemplateBuilder.emptySessionName"),
          heading: "Validation Error",
        });
      }, 0);
      return;
    }
    const sessionNames = sessions.map((session) => session.name.trim());
    const hasDuplicateSessionName = sessionNames.some(
      (name, index) => sessionNames.indexOf(name) !== index
    );
    if (hasDuplicateSessionName) {
      setToastConfig(null);
      setTimeout(() => {
        setToastConfig({
          type: "error",
          message: trans("WorkoutTemplateBuilder.duplicateSessionName"),
          heading: "Validation Error",
        });
      }, 0);
      return;
    }

    if (!sessions.length || !sessions.some((s) => s.exercises.length > 0)) {
      setToastConfig(null);
      setTimeout(() => {
        setToastConfig({
          type: "error",
          message: trans("WorkoutTemplateBuilder.atLeastOneSession"),
          heading: "Validation Error",
        });
      }, 0);
      return;
    }

    setIsSaving(true);

    const payload = {
      coachId: coachId,
      name: planName.trim(),
      description: planName,
      workoutTemplateImageBase64: coverState?.workoutTemplateImageBase64 || "",
      workoutTemplateImageFileName:
        coverState?.workoutTemplateImageFileName || "",
      workoutTemplateImageMediaType:
        coverState?.workoutTemplateImageMediaType || "",
      workoutTemplateImageFileType:
        coverState?.workoutTemplateImageFileType || "",
      workoutTemplateImageSourceType:
        coverState?.workoutTemplateImageSourceType || "",

      coverPhotoBase64: coverState?.coverPhotoBase64 || "",
      coverPhotoFileName: coverState?.coverPhotoFileName || "",
      coverPhotoMediaType: coverState?.coverPhotoMediaType || "",
      coverPhotoFileType: coverState?.coverPhotoFileType || "",
      coverPhotoSourceType: coverState?.coverPhotoSourceType || "",
      sessions: sessions.map((session) => {
        const hasImage = !!session.sessionPhotoBase64;

        return {
          sessionName: session.name,
          sessionType: session.sessionType || "",
          sessionImageId: hasImage ? uuidv4() : "",
          sessionPhotoBase64: session.sessionPhotoBase64 || "",
          sessionPhotoFileName: session.sessionPhotoFileName || "",
          sessionPhotoMediaType: session.sessionPhotoMediaType || "",
          sessionPhotoFileType: session.sessionPhotoFileType || "",
          sessionPhotoSourceType: session.sessionPhotoSourceType || "",
          indexOrder: session.indexOrder || 0,
          exercises: session.exercises.map((exercise) => ({
            exerciseID: exercise.exerciseId,
            sets: exercise.sets,
            reps: exercise.reps,
            sec: exercise.sec || "",
            setType: exercise.setType || "",
            exerciseNote: exercise.exerciseNote || "",
            indexOrder: exercise.indexOrder || 0,
          })),
        };
      }),
    };
    // Handle update if editing, otherwise create new template
    const apiCall = isEditing
      ? dispatch(
          updateWorkoutTemplate({
            templateId: location.state.templateId,
            workoutData: payload,
          })
        )
      : dispatch(createWorkoutTemplate(payload));

    apiCall
      .unwrap()
      .then(() => {
        navigate("/toolbox", { state: { activeTab: "workoutTemplate" } });
      })
      .catch((error) => {
        console.error(trans("ClientWorkout.failedWorkoutTemplate"), error);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const handleFileInputReset = (id) => {
    const fileInput = document.getElementById(id);
    fileInput.value = "";
  };

  const handleImageChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        let base64Image = reader.result;
        if (base64Image && base64Image.startsWith("data:")) {
          base64Image = base64Image.split(",")[1];
        }
        const fileType = file.type;
        const mediaType = fileType.split("/")[0];

        if (type === CONSTANTS.WORKOUT_PLAN_COVER) {
          setForm((prevData) => ({
            ...prevData,
            workoutPlanImageFileName: file.name,
            workoutPlanImageMediaType: mediaType,
            workoutPlanImageFileType: fileType,
            workoutPlanImageBase64: base64Image,
          }));
        }
        if (type === "templateMainCover") {
          if (type === "templateMainCover") {
            setCoverState((prev) => ({
              ...prev,
              workoutTemplateImageBase64: base64Image,
              workoutTemplateImageFileName: file.name,
              workoutTemplateImageMediaType: mediaType,
              workoutTemplateImageFileType: fileType,
              workoutTemplateImageSourceType: "WorkoutPlanCover",
              coverPhotoBase64: base64Image,
              coverPhotoFileName: file.name,
              coverPhotoMediaType: mediaType,
              coverPhotoFileType: fileType,
              coverPhotoSourceType: "TemplateMainCover",
            }));
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSessionClick = (id) => {
    setActiveSessionId(id);
  };

  const handleImageRemoveSession = (id) => {
    setForm((prevData) => {
      const updatedSessions = prevData.clientWorkoutPlanSessionRequests.map(
        (session) => {
          if (session.clientWorkoutPlanSessionId === id) {
            return {
              ...session,
              sessionPhotoBase64: null,
            };
          }
          return session;
        }
      );
      return {
        ...prevData,
        clientWorkoutPlanSessionRequests: updatedSessions,
      };
    });
  };

  const handleImageRemoveSessionTemplate = (id) => {
    setSessions((prevSessions) =>
      prevSessions.map((session) => {
        if (session.id === id) {
          return {
            ...session,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            sessionImageId: "",
          };
        }
        return session;
      })
    );
  };

  const handleImageChangeSessionTemplate = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        let base64Image = reader.result;
        if (base64Image && base64Image.startsWith("data:")) {
          base64Image = base64Image.split(",")[1];
        }
        const fileType = file.type;
        const mediaType = fileType.split("/")[0];

        // Update the specific session by matching id
        setSessions((prevSessions) =>
          prevSessions.map((session) => {
            if (session.id === id) {
              return {
                ...session,
                sessionPhotoFileName: file.name,
                sessionPhotoMediaType: mediaType,
                sessionPhotoFileType: fileType,
                sessionPhotoBase64: base64Image,
                sessionPhotoSourceType: "upload", // optional flag
              };
            }
            return session;
          })
        );
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageChangeSession = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        let base64Image = reader.result;
        if (base64Image && base64Image.startsWith("data:")) {
          base64Image = base64Image.split(",")[1];
        }
        const fileType = file.type;
        const mediaType = fileType.split("/")[0];

        // Update the specific session by filtering with clientWorkoutPlanSessionId
        setForm((prevData) => {
          const updatedSessions = prevData.clientWorkoutPlanSessionRequests.map(
            (session) => {
              if (session.clientWorkoutPlanSessionId === id) {
                return {
                  ...session,
                  sessionPhotoFileName: file.name,
                  sessionPhotoMediaType: mediaType,
                  sessionPhotoFileType: fileType,
                  sessionPhotoBase64: base64Image,
                };
              }
              return session;
            }
          );
          return {
            ...prevData,
            clientWorkoutPlanSessionRequests: updatedSessions,
          };
        });
      };
      reader.readAsDataURL(file);
    }
  };

  if (isSaving) {
    return <Loader />;
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="workout-template-builder">
        {/* Header */}
        <div className="template-header">
          <Button
            className={
              location?.state?.isSelectedFromClient
                ? "margin-top-button-template"
                : "margin-top-button-template "
            }
            variant="outline-secondary"
            onClick={() => {
              if (location?.state?.isSelectedFromClient) {
                navigate("/clients/clientDetails", {
                  state: {
                    client: location?.state?.selectedClientId,
                    type: "Workout",
                  },
                });
              } else {
                navigate("/toolbox", {
                  state: { activeTab: "workoutTemplate" },
                });
              }
            }}
          >
            Exit
          </Button>
          {location?.state?.isSelectedFromClient === false && (
            <div className="d-flex ">
              <div className="">
                <Input
                  type="text"
                  value={planName}
                  onChange={(e) => setPlanName(e.target.value)}
                  placeholder="Enter workout plan name"
                  className="plan-name-input-builder"
                />
              </div>

              <div className="mx-3 mt-1 image-container-formdata position-relative profile-image-container">
                {coverState?.workoutTemplateImageBase64 !== "" ? (
                  <Image
                    src={`data:${coverState.workoutTemplateImageBase64};base64,${coverState.workoutTemplateImageBase64}`}
                    alt="Profile Picture"
                    className="w-100 h-100 rounded-3"
                  />
                ) : (
                  <Image
                    src={WorkoutPlaceholder}
                    alt="Default Profile"
                    className="w-100 h-100 rounded-3 p-1"
                  />
                )}

                {coverState.workoutTemplateImageBase64 && (
                  <Button
                    variant="link"
                    className="position-absolute m-2 p-0 icon-position"
                    onClick={() => handleImageRemove("templateMainCover")}
                  >
                    <i
                      className="bi bi-x-circle-fill"
                      style={{ fontSize: "30px", color: "red" }}
                    ></i>
                  </Button>
                )}
                {!coverState.workoutTemplateImageBase64 && (
                  <Button
                    variant="link"
                    className="position-absolute m-2 p-0 icon-position"
                    onClick={() =>
                      document.getElementById("templateMainCover").click()
                    }
                  >
                    <i
                      className="bi bi-plus-circle-fill"
                      style={{ fontSize: "30px", color: "green" }}
                    ></i>
                  </Button>
                )}

                <input
                  type="file"
                  accept="image/*"
                  id="templateMainCover"
                  className="mt-2"
                  onChange={(e) => handleImageChange(e, "templateMainCover")}
                  style={{ display: "none" }}
                  onClick={() => handleFileInputReset("templateMainCover")}
                />
              </div>
            </div>
          )}

          {location?.state?.isSelectedFromClient ? (
            <Row style={{ width: "70%" }}>
              {/* LEFT COLUMN */}
              <Col xs={6} sm={6} md={6} lg={6}>
                <div className="d-flex justify-content-end mb-2">
                  <div
                    className="d-flex justify-content-end me-2"
                    style={{ width: 150 }}
                  >
                    <FormLabel
                      label={trans("ClientWorkout.workoutPlanName")}
                      required
                    />
                  </div>
                  {/* Control */}
                  <div
                    className="d-flex justify-content-start"
                    style={{ width: 300 }}
                  >
                    <FormControl
                      value={form?.name}
                      onChange={(e) => {
                        setErrors({});
                        setForm((prevData) => {
                          return {
                            ...prevData,
                            name: e.target.value,
                          };
                        });
                      }}
                      className="rounded-3"
                      containerClassName="w-100"
                      isInvalid={!!errors.EmptyName}
                      feedback={errors.EmptyName}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end mb-2">
                  <div
                    className="d-flex justify-content-end me-2"
                    style={{ width: 150 }}
                  >
                    <FormLabel
                      label={trans("ClientWorkout.introText")}
                      required
                    />
                  </div>
                  <div
                    className="d-flex justify-content-start"
                    style={{ width: 300 }}
                  >
                    <FormControl
                      value={form?.introText}
                      onChange={(e) => {
                        setErrors({});
                        setForm((prevData) => {
                          return {
                            ...prevData,
                            introText: e.target.value,
                          };
                        });
                      }}
                      className="rounded-3"
                      containerClassName="w-100"
                      isInvalid={!!errors.IntroRequired}
                      feedback={errors.IntroRequired}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end mb-2">
                  <div
                    className="d-flex justify-content-end me-2"
                    style={{ width: 150 }}
                  >
                    <FormLabel label={trans("ClientWorkout.description")} />
                  </div>
                  <div
                    className="d-flex justify-content-start"
                    style={{ width: 300 }}
                  >
                    <FormControlTextArea
                      className="rounded-3"
                      value={form?.description}
                      onChange={(e) => {
                        setForm((prevData) => {
                          setErrors({});
                          return {
                            ...prevData,
                            description: e.target.value,
                          };
                        });
                      }}
                      rows={2}
                      isInvalid={!!errors.DescriptionRequired}
                      feedback={errors.DescriptionRequired}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6}>
                <div className="mx-3 mt-1 image-container-formdata position-relative profile-image-container">
                  {form?.workoutPlanImageBase64 ? (
                    <Image
                      src={`data:${form?.workoutPlanImageFileType};base64,${form?.workoutPlanImageBase64}`}
                      alt="Profile Picture"
                      className="w-100 h-100 rounded-3"
                    />
                  ) : (
                    <Image
                      src={WorkoutPlaceholder}
                      alt="Default Profile"
                      className="w-100 h-100 rounded-3 p-1"
                    />
                  )}

                  {form?.workoutPlanImageBase64 && (
                    <Button
                      variant="link"
                      className="position-absolute m-2 p-0 icon-position"
                      onClick={() => handleImageRemove("workoutPlanCover")}
                    >
                      <i
                        className="bi bi-x-circle-fill"
                        style={{ fontSize: "30px", color: "red" }}
                      ></i>
                    </Button>
                  )}
                  {!form?.workoutPlanImageBase64 && (
                    <Button
                      variant="link"
                      className="position-absolute m-2 p-0 icon-position"
                      onClick={() =>
                        document.getElementById("workoutPlanCover").click()
                      }
                    >
                      <i
                        className="bi bi-plus-circle-fill"
                        style={{ fontSize: "30px", color: "green" }}
                      ></i>
                    </Button>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    id="workoutPlanCover"
                    className="mt-2"
                    onChange={(e) => handleImageChange(e, "workoutPlanCover")}
                    style={{ display: "none" }}
                    onClick={() => handleFileInputReset("workoutPlanCover")}
                  />
                </div>
              </Col>
            </Row>
          ) : (
            <div></div>
          )}
          {location?.state?.isSelectedFromClient ? (
            <div>
              <Button
                className={
                  location?.state?.isSelectedFromClient
                    ? "margin-top-button-template"
                    : ""
                }
                onClick={() => {
                  let isValid = true;
                  setErrors({});
                  const newErrors = {};
                  if (form.name.length === 0) {
                    newErrors.EmptyName = trans(
                      "ClientWorkout.workoutPlanRequired"
                    );
                    setErrors(newErrors);
                    isValid = false;
                  }
                  if (form.introText.length === 0) {
                    newErrors.IntroRequired = trans(
                      "ClientWorkout.introRequired"
                    );
                    setErrors(newErrors);
                    isValid = false;
                  }

                  if (isValid === false) {
                    return;
                  }

                  const sessionNames =
                    form.clientWorkoutPlanSessionRequests.map((session) =>
                      session.sessionName.trim().toLowerCase()
                    );
                  const hasDuplicateNames = sessionNames.some(
                    (name, index) => sessionNames.indexOf(name) !== index
                  );

                  if (hasDuplicateNames) {
                    setToastConfig({
                      type: CONSTANTS.TOAST_ERROR,
                      message: "Duplicate name found in sessions.",
                      heading: "Validation Error",
                    });
                    return;
                  }

                  if (
                    !Array.isArray(form.clientWorkoutPlanSessionRequests) ||
                    !form.clientWorkoutPlanSessionRequests.some(
                      (session) =>
                        Array.isArray(
                          session.clientWorkoutPlanExerciseRequests
                        ) &&
                        session.clientWorkoutPlanExerciseRequests.length > 0
                    )
                  ) {
                    setToastConfig({
                      type: CONSTANTS.TOAST_ERROR,
                      message: trans("ClientWorkout.atleastOneSession"),
                      heading: "Validation Error",
                    });
                    return;
                  }
                  setIsSaving(true);
                  dispatch(postWorkoutApi(form)).then(() => {
                    setIsSaving(false);
                    navigate("/clients/clientDetails", {
                      state: {
                        client: location?.state?.selectedClientId,
                        type: "Workout",
                        isForm: "true",
                      },
                    });
                  });
                }}
                disabled={isSaving}
              >
                {trans("ClientWorkout.saveWorkoutPlan")}
              </Button>
            </div>
          ) : (
            <div>
              <Button
                className="margin-top-button-template"
                onClick={handleSaveTemplate}
              >
                {trans("ClientWorkout.saveTemplate")}
              </Button>
            </div>
          )}
        </div>

        <Row className="main-content">
          {/* Left Sidebar - Sessions */}
          <Col md={3} className="sessions-sidebar">
            <h6>{trans("ClientWorkout.sessions")}</h6>
            <ul className="session-list">
              {!location?.state?.isSelectedFromClient &&
                sessions?.map((session) => (
                  <li
                    key={session.id}
                    className={`session-item ${
                      activeSessionId === session.id ? "active" : ""
                    } `}
                    onClick={() => {
                      handleSessionClick(session.id);
                    }}
                  >
                    <div>
                      <div className="mx-3 mt-1 image-container-sessions position-relative profile-image-container">
                        {session?.sessionPhotoBase64 ? (
                          <Image
                            src={`data:${session?.sessionPhotoFileType};base64,${session?.sessionPhotoBase64}`}
                            alt="Session Image"
                            className="w-100 h-100 rounded-3"
                          />
                        ) : (
                          <Image
                            src={WorkoutSessionPlaceholder}
                            alt="Default Session"
                            className="w-100 h-100 rounded-3 p-1"
                          />
                        )}

                        {session?.sessionPhotoBase64 ? (
                          <Button
                            variant="link"
                            className="position-absolute m-2 p-0 icon-position-session"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleImageRemoveSessionTemplate(session.id);
                            }}
                          >
                            <i
                              className="bi bi-x-circle-fill"
                              style={{ fontSize: "30px", color: "red" }}
                            ></i>
                          </Button>
                        ) : (
                          <Button
                            variant="link"
                            className="position-absolute m-2 p-0 icon-position-session"
                            onClick={(e) => {
                              e.stopPropagation();
                              document
                                .getElementById(
                                  `workoutTemplateSession-${session.id}`
                                )
                                .click();
                            }}
                          >
                            <i
                              className="bi bi-plus-circle-fill"
                              style={{ fontSize: "30px", color: "green" }}
                            ></i>
                          </Button>
                        )}

                        <input
                          type="file"
                          accept="image/*"
                          id={`workoutTemplateSession-${session.id}`}
                          className="mt-2"
                          style={{ display: "none" }}
                          onChange={(e) =>
                            handleImageChangeSessionTemplate(e, session.id)
                          }
                          onClick={() =>
                            handleFileInputReset(
                              `workoutTemplateSession-${session.id}`
                            )
                          }
                        />
                      </div>
                    </div>
                    <input
                      type="text"
                      value={session.name}
                      onChange={(e) => {
                        const updatedSessions = sessions.map((s) =>
                          s.id === session.id
                            ? { ...s, name: e.target.value }
                            : s
                        );
                        setSessions(updatedSessions);

                        setForm((prevForm) => {
                          const updatedSessions =
                            prevForm?.clientWorkoutPlanSessionRequests?.map(
                              (sessions) => {
                                if (
                                  sessions.clientWorkoutPlanSessionId ===
                                  session.clientWorkoutPlanSessionId
                                ) {
                                  return {
                                    ...sessions,
                                    sessionName: e.target.value,
                                  };
                                }
                                return sessions;
                              }
                            );

                          return {
                            ...prevForm,
                            clientWorkoutPlanSessionRequests: updatedSessions,
                          };
                        });
                      }}
                      className="session-name-input "
                    />

                    <span
                      className="remove-session"
                      onClick={(e) => handleRemoveSession(session.id)}
                    >
                      X
                    </span>
                  </li>
                ))}
              {location?.state?.isSelectedFromClient && (
                <DndProvider backend={HTML5Backend}>
                  {form?.clientWorkoutPlanSessionRequests?.map(
                    (session, index) => (
                      <SessionCard
                        key={session.clientWorkoutPlanSessionId}
                        session={session}
                        index={index}
                        activeSessionId={activeSessionId}
                        placeholderFrontImage={WorkoutSessionPlaceholder}
                        handleSessionClick={handleSessionClick}
                        handleImageRemoveSession={handleImageRemoveSession}
                        handleImageChangeSession={handleImageChangeSession}
                        handleFileInputReset={handleFileInputReset}
                        handleRemoveSession={handleRemoveSession}
                        setSessions={setSessions}
                        setForm={setForm}
                        form={form}
                        moveSession={moveSession}
                      />
                    )
                  )}
                </DndProvider>
              )}
            </ul>

            <Button className="add-session-btn" onClick={handleAddSession}>
              + Add Session
            </Button>
          </Col>

          {/* Middle Section - Drag & Drop Workspace */}
          <Col md={6} className="workspace">
            {location?.state?.isSelectedFromClient ? (
              <div className="h-100">
                {sessions.length === 0 ||
                !form?.clientWorkoutPlanSessionRequests ? (
                  <p className="empty-text">Add a session to start</p>
                ) : (
                  (location?.state?.isSelectedFromClient
                    ? form?.clientWorkoutPlanSessionRequests
                    : sessions
                  ).map(
                    (session) =>
                      (activeSessionId === session.id ||
                        activeSessionId ===
                          session.clientWorkoutPlanSessionId) && (
                        <div className="h-100">
                          <Session
                            isform={location?.state?.isSelectedFromClient}
                            key={session.id}
                            session={session}
                            setSessions={setSessions}
                            form={form}
                            setForm={setForm}
                          />
                        </div>
                      )
                  )
                )}
              </div>
            ) : (
              <div className="h-100">
                {sessions.map(
                  (session) =>
                    (activeSessionId === session.id ||
                      activeSessionId ===
                        session.clientWorkoutPlanSessionId) && (
                      <div className="h-100">
                        <Session
                          isform={false}
                          key={session.id}
                          session={session}
                          setSessions={setSessions}
                          form={form}
                          setForm={setForm}
                        />
                      </div>
                    )
                )}
              </div>
            )}
          </Col>

          {/* Right Sidebar - Exercises */}
          <Col md={3} className="exercises-sidebar">
            <Tabs
              defaultActiveKey="1"
              onChange={(key) => setIsCustomized(key === "2")}
              style={{ marginTop: "-25px" }}
            >
              <TabPane tab="Exercises" key="1" />
              <TabPane tab="Customized" key="2" />
            </Tabs>

            <ExerciseList isCustomized={isCustomized} />
          </Col>
        </Row>
      </div>
      {toastConfig && (
        <ToastNotification
          type={toastConfig.type}
          message={toastConfig.message}
          heading={toastConfig.heading}
          onClose={() => setToastConfig(null)}
        />
      )}
    </DndProvider>
  );
};

export default WorkoutTemplateBuilder;
